<template>
  <v-container grid-list-md fluid class="pa-0 grey lighten-4 pa-2 card-r">

      <v-layout>
        <v-flex>
          <v-img size="36px" :src="coverPhoto" class="CoverPhoto card-r"></v-img>
          <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">edit</v-icon></v-btn>-->
          <v-btn icon v-bind:to="'/teachers/edit/'+Teachers.id" flat color="grey" class="text-xs-right shadow-1 right ma-0"><v-icon>edit</v-icon></v-btn>
          <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">delete</v-icon></v-btn>-->
          <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">block</v-icon></v-btn>-->
        </v-flex>
      </v-layout>
      <v-layout row class="text-xs-center">
        <v-flex xs12 class="profileImgd">
          <v-img :src="Teachers.image" class="boxShadow"></v-img>
        </v-flex>
      </v-layout>
      <v-container fluid grid-list-xl class="pa-0 pb-2">
        <v-layout row wrap class="">
          <v-flex d-flex lg12 sm12 xs12>
            <div class="text-xs-center">
              <span class="headline font-weight-black text-capitalize">{{Teachers.name}}</span> <br>

              <p class="">
                Teachers create lesson plans and teach those plans to the entire class, individually to
                students or in small groups, track student progress and present the information to parents,
                create tests, create and reinforce classroom rules, work with school administration prepare
                students for standardized tests, and manage ...</p>
            </div>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shodow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p> Full Name </p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0 pa-0">{{Teachers.name}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shodow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs2 class="label pa-0"><p>Email</p> </v-flex>
                <v-flex xs10 class="word-break text-xs-right pa-0 pa-0">{{Teachers.email}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shodow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Phone Number</p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0 pa-0">{{Teachers.phone}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shodow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Date of Birth</p> </v-flex>
                 <v-flex xs6 class="word-break text-xs-right pa-0 pa-0">{{Teachers.dob}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
                <v-flex d-flex lg4 sm6 xs12 class="pb-0">
                <v-card class="PersonalCards pa-0  shodow-1 card-r">
                <v-layout row class="ma-0" >
                  <v-flex xs3 class="label pa-0"><p>Address</p> </v-flex>
                  <v-flex xs9 class="word-break text-xs-right pa-0 pa-0">{{TeacherAddress}}</v-flex>
                </v-layout>
              </v-card>
            </v-flex>

          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shodow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Zip Code</p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0 pa-0">{{Teachers.zipCode}}</v-flex>.
              </v-layout>
            </v-card>
          </v-flex>
          <!--<v-flex d-flex lg4 sm6 xs12 class="pa-0">-->
            <!--<v-card class="PersonalCards pa-0  shodow-1 card-r">-->
              <!--<v-layout row class="ma-0 ">-->
                <!--<v-flex xs6 class="label pa-0"><p>City</p> </v-flex>-->
                <!--<v-flex xs6>krt7inkfguybh</v-flex>-->
              <!--</v-layout>-->
            <!--</v-card>-->
          <!--</v-flex>-->
          <!--<v-flex d-flex lg4 sm6 xs12 class="pa-0">-->
            <!--<v-card class="PersonalCards pa-0  shodow-1 card-r">-->
              <!--<v-layout row class="ma-0 ">-->
                <!--<v-flex xs6 class="label pa-0"><p>State</p> </v-flex>-->
                <!--<v-flex xs6>krt7inkfguybh</v-flex>-->
              <!--</v-layout>-->
            <!--</v-card>-->
          <!--</v-flex>-->
          <!--<v-flex d-flex lg4 sm6 xs12 class="pa-0">-->
            <!--<v-card class="PersonalCards pa-0  shodow-1 card-r">-->
              <!--<v-layout row class="ma-0 ">-->
                <!--<v-flex xs6 class="label"><p>Postal Code</p> </v-flex>-->
                <!--<v-flex xs6>krt7inkfguybh</v-flex>-->
              <!--</v-layout>-->
            <!--</v-card>-->
          <!--</v-flex>-->
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shodow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Gender</p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0">{{Teachers.gender}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shodow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Pickup Location</p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0">{{Teachers.pickup_location}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <!--<v-flex d-flex lg4 sm6 xs12 class="pa-0">-->
            <!--<v-card class="PersonalCards pa-0  shodow-1 card-r">-->
              <!--<v-layout row class="ma-0 ">-->
                <!--<v-flex xs6 class="label"><p> Full Name </p> </v-flex>-->
                <!--<v-flex xs6>krt7inkfguybh</v-flex>-->
              <!--</v-layout>-->
            <!--</v-card>-->
          <!--</v-flex>-->
        </v-layout>
      </v-container>
      <!--</v-layout>-->
    </v-container>
</template>
<script>
  /* eslint-disable */
  // import EditProfile from './EditProfile'
    import { mapState, dispatch } from "vuex";
  export default {
    name: "personal",
    data: () => ({
      coverPhoto: "https://s3.amazonaws.com/stg-drivers-license-assistance.org/images/blog/find-driving-teacher.jpg",
      ProfileImg: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
      TeacherAddress:"",
    }),
    props:['id'],
    created() {
        this.teacherId = this.$route.params.id;
        Store.dispatch("Teachers/getTeacherById", this.teacherId).then(res => {
        });
    },
    methods:{
      nullCheck(value){
          if(value){
            return value+' ';
          }else if(value==undefined){
            return ""
          }else{
            return ""
          }
      },
    },
    // mount:function(){
    //     this.TeacherAddress=this.nullCheck(this.Teachers.street)+' '+
    //                  this.nullCheck(this.Teachers.streetNumber)+' '+
    //                  this.nullCheck(this.Teachers.floor)+' '+
    //                   this.nullCheck(this.Teachers.door)+' '+
    //                   this.nullCheck(this.Teachers.zipCode)+' '+
    //                   this.nullCheck(this.Teachers.city)
    // },
    watch:{
      Teachers:function(){
          this.TeacherAddress=this.nullCheck(this.Teachers.street)+' '+
                     this.nullCheck(this.Teachers.streetNumber)+' '+
                     this.nullCheck(this.Teachers.floor)+' '+
                      this.nullCheck(this.Teachers.door)+' '+
                      this.nullCheck(this.Teachers.zipCode)+' '+
                      this.nullCheck(this.Teachers.city)
      }
    },
    computed: {
        ...mapState({
              Teachers: 'Teachers',
              loading: 'loading',
              mode: 'mode',
              Teachers: Teachers => Store.state.Teachers.Teachers
        })
    },

  };
</script>



// WEBPACK FOOTER //
// src/components/profile/teacher/TeacherPersonal.vue